import { CountryISOCodes } from 'common/countries';
import { useAppSelector } from 'hooks';

import { getCurrencyByCountry } from 'utils/currency';
import {
  getBusinessCountry,
  getCurrencyCodes,
} from 'pages/dashboard/selectors';

type CurrencyPrefixProps = {
  currencyCode?: string;
};

const CurrencyPrefix: React.FC<CurrencyPrefixProps> = ({
  currencyCode = null,
}) => {
  const businessCountry = useAppSelector(getBusinessCountry);
  const currencies = useAppSelector(getCurrencyCodes);

  const code =
    currencyCode ||
    currencies.find(
      (c) =>
        c.alphaCode ===
        getCurrencyByCountry(businessCountry?.iSOCode as CountryISOCodes),
    )?.alphaCode;

  const selectedCurrency = currencies.find((c) => c.alphaCode === code);

  return (
    <span className="block text-center text-lg w-5 text-gray-400">
      {selectedCurrency?.currencySymbol}
    </span>
  );
};

export default CurrencyPrefix;
